import { useEffect, useRef, useState } from "react";
import { MessageCircle, Send, Users } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { useFeature } from "@/contexts/FeaturesContext";

/*
 * Mesaje cu Georgiana (chat asincron client↔terapeut) — golul identificat în analiza
 * concurenței (doar terapie.app îl avea). Continuitate între ședințe, direct în panou.
 */


/* „Adu un prieten" — referral cu Semințe pentru amândoi (unic în piață pe monedă internă) */
export function ReferralCard() {
  const enabled = useFeature("referral");
  const [d, setD] = useState(null);
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => { if (enabled) api.get("/me/referral").then((r) => setD(r.data)).catch(() => {}); }, [enabled]);
  if (!enabled || !d) return null;

  const claim = async () => {
    if (code.trim().length < 4) return;
    setBusy(true);
    try {
      const { data } = await api.post("/me/referral/claim", { code });
      toast.success(data.message, { icon: "🌱", duration: 7000 });
      setCode("");
      api.get("/me/referral").then((r) => setD(r.data)).catch(() => {});
    } catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); }
  };

  const copyCode = () => {
    const ok = () => toast.success("Cod copiat.");
    if (navigator.clipboard?.writeText) {
      navigator.clipboard.writeText(d.code).then(ok).catch(() => fallbackCopy());
      return;
    }
    fallbackCopy();
    function fallbackCopy() {
      try {
        const ta = document.createElement("textarea");
        ta.value = d.code; ta.style.position = "fixed"; ta.style.opacity = "0";
        document.body.appendChild(ta); ta.select();
        const done = document.execCommand("copy");
        document.body.removeChild(ta);
        if (done) ok(); else toast.error("Nu am putut copia. Selectează codul manual.");
      } catch (_) { toast.error("Nu am putut copia. Selectează codul manual."); }
    }
  };

  return (
    <div className="card-premium p-6" data-testid="referral-card">
      <h3 className="font-serif text-lg mb-1 inline-flex items-center gap-2">
        <Users size={16} style={{ color: "var(--ct-gold)" }} /> Adu un prieten
      </h3>
      <p className="text-[11px] mb-3" style={{ color: "var(--ct-text-dim)" }}>
        Cunoști pe cineva care ar avea nevoie de locul ăsta? Dă-i codul tău — când îl folosește,
        primiți amândoi câte {d.reward} Semințe.
      </p>
      <div className="p-3 rounded-xl text-center mb-3" style={{ background: "var(--ct-bg-soft)" }}>
        <p className="text-[11px] mb-0.5" style={{ color: "var(--ct-text-dim)" }}>Codul tău:</p>
        <button type="button" className="font-mono text-2xl tracking-[0.3em]" style={{ color: "var(--ct-link)" }}
          onClick={copyCode} title="Apasă ca să copiezi">
          {d.code}
        </button>
        {d.joined > 0 && <p className="text-[11px] mt-1" style={{ color: "var(--ct-gold)" }}>🌱 {d.joined} {d.joined === 1 ? "prieten a venit" : "prieteni au venit"} datorită ție</p>}
      </div>
      {!d.already_used_a_code && (
        <div className="flex gap-2">
          <input value={code} onChange={(e) => setCode(e.target.value.toUpperCase())}
            className="premium-input flex-1 text-sm font-mono tracking-widest" placeholder="Ai primit un cod?" maxLength={12} />
          <button type="button" onClick={claim} disabled={busy} className="btn-ghost text-sm">Folosește</button>
        </div>
      )}
    </div>
  );
}
